import { Diff, Entity, IdentityEntity, Mutation } from "../";
import { ObjectRepository } from "./ObjectRepository";

interface EntityRepository<T extends Entity<T>> {
    getAll(): T[];
    get(uuid: string) : T | undefined;
    put(uuid: string, value: T) : Promise<void>;
    putAll(values: T[]) : void;
    delete(uuid:string) : void;
    checkUniqueString(attribute:(obj:T) => string, value: string) : boolean;

}

class CRUDEntityRepository<T extends Entity<T>> implements EntityRepository<T> {

    private _innerRepo: ObjectRepository<T>;
    private _type: IdentityEntity<T>;
    constructor(type: IdentityEntity<T>, innerRepo: ObjectRepository<T>) {
        this._type = type;
        this._innerRepo = innerRepo;
    }

    getAll() : T[] {
        return this._innerRepo.getAll();
    }

    get(uuid: string): T | undefined {
        return this._innerRepo.findById(uuid);
    }

    async put(uuid: string, value: T) {
        const existing = this.get(uuid);
        const initialState = existing ? existing.builder() : this._type.identity().builder();
        const mutationType: Mutation = existing ? "EDIT" : "ADD";
        const diffContent = initialState
            .applyObj(value)
            .getDiff();
        
        const diff:Diff<T> = {
            type: mutationType,
            content: diffContent
        }

        await this._innerRepo.append(uuid, diff);
    }

    async putAll(values: T[]) {
        values.forEach(val => this.put(val.uuid, val));
    }

    async delete(uuid: string) {
        const deleteDiffContent = this._type.identity().builder().getDiff();
        const deleteDiff : Diff<T> = {
            type: "DELETE",
            content: deleteDiffContent
        }

        await this._innerRepo.append(uuid, deleteDiff);
    }

    checkUniqueString(attribute:(obj:T) => string, value: string) : boolean {
        const existingAttr = this.getAll()
            .map(obj => attribute(obj))
            .find(str => str === value);
        return existingAttr ? false : true;
    }
}


export {EntityRepository, CRUDEntityRepository};